import * as z from "zod";

export const WeatherHourDtoSchema = z.object({
    etc: z.number().nullish(),
    hour: z.string().trim(),
    humidity: z.number(),
    icon: z.string().trim(),
    rain_prob: z.number(),
    rain_fall: z.number(),
    temperature: z.number(),
    wind_direction: z.string().trim(),
    wind_speed_from: z.number(),
    wind_speed_to: z.number(),
});
export type WeatherHourDto = z.output<typeof WeatherHourDtoSchema>;
